import { create } from 'zustand';
import localforage from 'localforage';

interface DraftData {
  [key: string]: unknown;
}

interface DraftState {
  drafts: Record<string, DraftData>;
  saveDraft: (formId: string, data: DraftData) => Promise<void>;
  loadDraft: (formId: string) => Promise<DraftData | null>;
  deleteDraft: (formId: string) => Promise<void>;
  clearAllDrafts: () => Promise<void>;
  getDraftIds: () => Promise<string[]>;
}

const draftStore = localforage.createInstance({
  name: 'bluepages',
  storeName: 'form-drafts',
});

export const useDraftStore = create<DraftState>((set, get) => ({
  drafts: {},

  saveDraft: async (formId, data) => {
    await draftStore.setItem(formId, data);
    set((state) => ({
      drafts: { ...state.drafts, [formId]: data },
    }));
  },

  loadDraft: async (formId) => {
    const cached = get().drafts[formId];
    if (cached) return cached;

    const data = await draftStore.getItem<DraftData>(formId);
    if (data) {
      set((state) => ({
        drafts: { ...state.drafts, [formId]: data },
      }));
    }
    return data;
  },

  deleteDraft: async (formId) => {
    await draftStore.removeItem(formId);
    set((state) => {
      const drafts = { ...state.drafts };
      delete drafts[formId];
      return { drafts };
    });
  },

  clearAllDrafts: async () => {
    await draftStore.clear();
    set({ drafts: {} });
  },

  getDraftIds: async () => {
    const keys: string[] = [];
    await draftStore.iterate((_value, key) => {
      keys.push(key);
    });
    return keys;
  },
}));
